import type { GenericHttpResponse } from '@iconik-io/core/src/http/generic_http_transport';

export const unwrapHeaderValue = (
  response: GenericHttpResponse,
  name: string,
): string => {
  const value = response.headers[name];
  if (value && !Array.isArray(value)) {
    return value;
  }
  throw new Error(
    `Can't unwrap header ${name} the value is ${value} on ${response.request.method} ${response.request.url}`,
  );
};
